// Dois caracteres só no TLD final: rótulo intermediário de um caractere existe em
// domínio real, como "x.com".
const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/;

export function validateEmail(email) {
  if (typeof email !== "string") return false;

  return EMAIL_PATTERN.test(email.trim());
}
